// extracted by mini-css-extract-plugin
export default {"tabsbar_contianer":"TabsBar_tabsbar_contianer__Ii+r1","item_container":"TabsBar_item_container__lU5-t","item":"TabsBar_item__wEOta","item_active":"TabsBar_item_active__g-Hy4"};